function encodeUrlWithParams(url) {
    if (!url) {
        return;
    }

    var urlArray = url.split('?');
    var baseUrl = urlArray[0];

    // WEB-3591: only encode when there is actually something to encode.
    // getApiURL()/getReportURL() now always leave a query separator on the URL
    // (see http.js), so a URL with no params of its own reaches here as
    // 'path?'. encodeParams('') returns undefined, which used to be
    // concatenated into a literal '?undefined' query.
    if (urlArray.length > 1 && urlArray[1]) {
        baseUrl += '?' + encodeParams(urlArray[1]);
    }

    return baseUrl;
}

function encodeParams(params) {
    if (!params) {
        return;
    }

    var isString = typeof params === 'string' || params instanceof String;
    var isObject = typeof params === 'object';

    if (isString) {
        return 'q=' + customB64Encode(params);
    } else if (isObject) {
        return {
            'q': customB64Encode(JSON.stringify(params))
        };
    }
}

function customB64Encode(str) {
    var c1 = generateCode(1, CODE_LCHARS + CODE_UCHARS);
    var c2 = generateCode(1, CODE_LCHARS + CODE_UCHARS);
    var c3 = generateCode(1, CODE_LCHARS + CODE_UCHARS);

    str = btoa(encodeURIComponent(str));
    var mid = str.length / 2;

    return c1 + str.substr(0, mid) + c2 + str.substr(mid) + c3;
}